import React from "react";
import injectSheet from "react-jss";
import Hint from "components/Hint";
import Markdown from "components/Markdown";

const styles = ({ theme }) => ({
  root: {
    padding: 0,
    border: "none"
  },
  item: {
    margin: [0, 0, theme.padding.md, 0]
  },
  description: {
    marginBottom: theme.margin.sm
  }
});

const ObjectFieldTemplate = ({
  TitleField,
  title: titleFromSchema,
  description,
  properties,
  uiSchema,
  classes
}) => {
  const title = uiSchema["ui:hideTitle"] === true ? null : titleFromSchema;
  return (
    <fieldset className={classes.root}>
      {title ? <TitleField title={title} /> : null}

      {description ? (
        <div className={classes.description}>
          <Hint>
            <Markdown source={description} />
          </Hint>
        </div>
      ) : null}

      <>
        {properties.map(prop => (
          <div className={classes.item} key={prop.content.key}>
            {prop.content}
          </div>
        ))}
      </>
    </fieldset>
  );
};

export default injectSheet(styles)(ObjectFieldTemplate);
